import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpStatusCode
} from '@angular/common/http';

import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { shouldRetry } from '@app/shared/rxjs/custom-operators';
import { getRemoteError } from '@app/shared/utils/get-remote-error.utils';

const EXCLUDED_STATUS_CODES_ON_RETRY = [
  HttpStatusCode.NotFound,
  HttpStatusCode.Unauthorized,
  HttpStatusCode.UnprocessableEntity
];

const retryConfig = {
  maxRetryAttempts: 1,
  scalingDuration: 3000,
  excludedStatusCodes: EXCLUDED_STATUS_CODES_ON_RETRY
} as const;

const createErrorResponse = (response: HttpErrorResponse) => {
  const { message, severity, status } = getRemoteError(response);

  return new HttpErrorResponse({
    ...response,
    error: {
      ...response.error,
      status: status ?? response.status,
      severity,
      message,
      stack: {
        ...(typeof response.error?.stack === 'object'
          ? response.error.stack
          : {}),
        url: response.url
      }
    }
  });
};

export const responseProtocolInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retry(shouldRetry(retryConfig)),
    catchError((err: HttpErrorResponse) =>
      throwError(() => createErrorResponse(err))
    )
  );
};
